import * as tokens from '@joinrepublic/dls-ui-core';

import { ThemeName } from '../types/theme-name';
import { hasProperty } from './has-property';

export const getTokens = (themName: ThemeName) =>
  hasProperty(tokens, themName) ? tokens[themName as keyof typeof tokens] : {};
